const initialState = {
    username: '',
    darkMode: 'light',
    highcontrast: 'light',
    openmodal: false,
    theme: 'theme-blue',
}

const Mainreducer = (state = initialState, action) => {
    switch (action.type) {
        case 'USER_NAME':
            return {
                ...state,
                username: action.payload
            };
        case 'OPEN_MODAL':
            return {
                ...state,
                openmodal: action.payload
            };
        case 'DARK_MODE':
            return {
                ...state,
                darkMode: action.payload
            };
        case 'HIGH_CONTRAST':
            return {
                ...state,
                highcontrast: action.payload
            };
        case 'THEME_COLOR':
            return {
                ...state,
                theme: action.payload
            };
        default:
            return state;
    }
}

export default Mainreducer;